import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { Enums, PersonioSyncState } from "@msuite/utils/types";
import type { PersonioSyncRow } from "./utils";

/** Props Interface */
interface PersonioSyncStateTagProps {
	row: PersonioSyncRow;
}

/** One colour per state, so the work the sync will do reads apart from what is already done. */
const STATE_COLORS: Record<PersonioSyncState, Enums<"color">> = {
	linked: "emerald",
	link: "blue",
	create: "amber",
	adopt: "violet",
	blocked: "gray",
};

export function PersonioSyncStateTag({ row }: PersonioSyncStateTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const state: PersonioSyncState = row.action ?? row.state;

	/** Render */
	return (
		<Tag
			variant="plain"
			color={STATE_COLORS[state]}
		>
			{t(`integrations.personio_sync.states.${state}`)}
		</Tag>
	);
}
